class Loading extends HTMLElement {
  constructor() {
    super();

    this.loading = this.querySelector('.wl-loading');
  }
  show() {
    this.loading.classList.add('wl-loading--active');
  }
  hide() {
    this.loading.classList.remove('wl-loading--active');
  }
}

if (!customElements.get('wl-loading')) {
    customElements.define('wl-loading', Loading)
}